const DEFAULT_PUBLIC_APP_URL = 'https://app.washdaypos.com';

export const getPublicAppBaseUrl = (): string => {
  const configuredUrl = import.meta.env.REACT_APP_PUBLIC_APP_URL?.trim();
  const baseUrl = configuredUrl || DEFAULT_PUBLIC_APP_URL;

  return baseUrl.replace(/\/+$/, '');
};

export const buildPublicAppUrl = (path: string): string =>
  new URL(path.replace(/^\/+/, ''), `${getPublicAppBaseUrl()}/`).toString();
